import * as z from 'zod'
import { TimestampMetadataSchema } from './_common'

/**
 * [@]: /brands/{brandId}
 */
export const BrandSchema = z.object({
  id: z.string().nonempty(),
  accountId: z.string().nonempty(),
  brandName: z.string().nonempty(),
  ...TimestampMetadataSchema.shape,
})

export type LooseBrand = z.input<typeof BrandSchema>
export type Brand = z.output<typeof BrandSchema>